import React, { useState,useEffect } from 'react'
import Table from './Table'
import { setCurrentRule } from '../../../../reducers/JsonRuleEditor/RulesActions';
import { useSelector, useDispatch } from 'react-redux';

const headings = {
    id:"id",
    ruleName: "Rule Name",
    
};

// const data = [
//     { id: "1", ruleName: "First One"},
//     { id: "2", ruleName: "First Second"},
// ];

export default function RulesList({handleView, handleViewData}) {
    // const [searchText, setsearchText] = useState("")
    const [searchText, setSearchText] = useState("");
    const dispatch = useDispatch();
    const rulesList = useSelector(state => state.JsonRulesEditorReducer.rulesList);
    const [displayRules, setDisplayRules] = useState([]);
    // const [DataField, setDataField] = useState(data)

    useEffect(() => {
        setDisplayRules(rulesList);
    }, [rulesList]);

    // const handleSearch = (e) => {
    //     if(searchText == ""){
    //         setDataField(data)
    //     }else{
    //         const filtered = data.filter((el) =>
    //             el.ruleName?.toLowerCase().includes(searchText.toLowerCase())
    //         );
    //         setDataField(filtered);
    //     }
    // }

    const handleSearch = () => {
        if (searchText === "") {
            setDisplayRules(rulesList);
        } else {
            const filtered = rulesList.filter((el) =>
                el.ruleName?.toLowerCase().includes(searchText.toLowerCase())
            );
            setDisplayRules(filtered);
        }
    };

    // const handleViewFn =(type,data)=>{
    //     if(type === "add"){
    //         handleView(type)
    //     }else if(type === "view"){
    //         handleViewData(data)
    //         handleView(type)
    //     }else if(type === "delete"){

    //     }
    // }

    const handleViewFn = (type, data) => {
        if (type === "add") {
            handleView(type);
        } else if (type === "view") {
            dispatch(setCurrentRule(data));
            handleViewData(data);
            handleView(type);
        } else if (type === "delete") {
            // Implement delete functionality
        }
    };

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-2 col-xs-12">
                        <input type='text' className='form-control' onKeyDown={(e) => e.key === 'Enter' && handleSearch()} value={searchText} onChange={(e) => {
                                setSearchText(e.target.value);
                                if (e.target.value === '') handleSearch();
                            }}  placeholder='Type here...' />
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <button className='addbtn' onClick={()=>handleViewFn("add","")}><i class="fa fa-plus" aria-hidden="true"></i>&nbsp;Add Rules</button>
                    </div>

                    <div className="col-xs-12" style={{marginTop:'30px'}}>
                        <Table headingsObj={headings} DataArray={displayRules} includeView={true} handleViewFn={handleViewFn}/>
                    </div>
                </div>
            </div>
        </>
    )
}
